import React from 'react';
import * as PropTypes from 'prop-types';
import cx from 'classnames';
import Button from '../Button';
import Close from '../Close';
import Icon from '../../../Icon';
import hs0Image from './header-status-0@3x.jpg';
import hs1Image from './header-status-1@3x.jpg';
import hs2Image from './header-status-2@3x.jpg';
import './style.scss';

const renderStatus = (status) => {
  switch (status) {
    case 0:
      return <span>待领取</span>;
    case 1:
      return <span>点击领取</span>;
    default:
      return <Icon name="bingo2" className="icon-bingo" />;
  }
};

const getHeaderImage = (status, isRestart, finishDay = 0) => {
  if (status === 1) {
    return hs1Image;
  }

  if (status === 2) {
    return hs0Image;
  }

  if (isRestart && finishDay === 0) {
    return hs2Image;
  }

  return hs0Image;
};

const Home = (
  {
    awards, day, onRuleButtonClick, onAwardItemClick, onClose, onStartCountdown,
    status, isRestart
  }
) => {
  const finishDay = awards.filter(_ => _.status > 0).length;
  const todayAward = awards.find(_ => _.offset === day);
  const todayIsDone = !!todayAward && todayAward.status > 0;
  const buttonText = todayIsDone ? '今天任务已完成' : `去完成 (${finishDay}/7天)`;
  const headerImage = getHeaderImage(status, isRestart, finishDay);
  return (
    <article className="ap-home">
      <section className="ap-home-main">
        <section className="ap-home-body" style={{ backgroundImage: `url(${headerImage})` }}>
          <section className="ap-home-rule-button" onClick={onRuleButtonClick}>
            <span>活动详情</span>
            <Icon name="arrow_new" className="icon-arrow" />
          </section>
          <section className="ap-home-progress">
            <ul className="ap-home-award-list">
              {
                awards.map((award) => {
                  const {
                    offset, title, status, backgroundColor, logo
                  } = award;
                  return (
                    <li
                      key={offset}
                      className="ap-home-award-item"
                      style={{ background: backgroundColor }}
                      onClick={
                        () => {
                          onAwardItemClick(award);
                        }
                      }
                    >
                      <div className="info">
                        <div
                          className={cx('info-flag', {
                            'is-active': offset === day
                          })}
                        />
                        <div className="info-index">{offset}</div>
                        <div className="info-logo" style={{ backgroundImage: `url(${logo})` }} />
                        <div className="info-name">{title}</div>
                      </div>
                      <div className="status">
                        {renderStatus(status)}
                      </div>
                    </li>
                  );
                })
              }
            </ul>
            <p className="ap-home-notice">
              {
                day > 0 && '若打卡中断，就会重新开始哦~'
              }
            </p>
            <section className="ap-home-go">
              <Button text={buttonText} onClick={todayIsDone ? null : onStartCountdown} size="small" />
            </section>
          </section>
        </section>
      </section>
      <section className="ap-home-close">
        <Close onClick={onClose} />
      </section>
    </article>
  );
};

Home.propTypes = {
  status: PropTypes.number.isRequired,
  isRestart: PropTypes.bool.isRequired,
  awards: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  day: PropTypes.number.isRequired,
  onRuleButtonClick: PropTypes.func.isRequired,
  onAwardItemClick: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  // onGoToMall: PropTypes.func.isRequired,
  onStartCountdown: PropTypes.func.isRequired
};

export default Home;
